var _rect, _g, _text, _rect2, _rect3, _line, _line2, _line3, _line4, _line5, _line6, _text2, _text3, _text4, _path, _circle, _circle2, _line7, _line8, _line9, _text5, _path2, _line10, _g2, _text6, _text7, _text8, _text9, _text10, _text11, _text12, _text13, _g3, _text14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProtecaoTemperaturaBaixa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1280 660",
    fontFamily: "Inter, sans-serif",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1280,
    height: 660,
    fill: "#FFFFFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#E2E4E9",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 110,
    x2: 1030,
    y2: 110
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 138,
    x2: 1030,
    y2: 138
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 166,
    x2: 1030,
    y2: 166
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 194,
    x2: 1030,
    y2: 194
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 250,
    x2: 1030,
    y2: 250
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 306,
    x2: 1030,
    y2: 306
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 420,
    x2: 1030,
    y2: 420
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 455,
    x2: 1030,
    y2: 455
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 490,
    x2: 1030,
    y2: 490
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 525,
    x2: 1030,
    y2: 525
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 30,
    y: 30,
    fontSize: 20,
    fontWeight: 600,
    fill: "#0A0D14"
  }, "Prote\xE7\xE3o Contra Temperatura Baixa")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 106,
    width: 840,
    height: 56,
    fill: "#EEF4FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 302,
    width: 840,
    height: 28,
    fill: "#FFFBEC"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 106,
    x2: 1030,
    y2: 106,
    stroke: "#C8D8FD",
    strokeWidth: 1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 162,
    x2: 1030,
    y2: 162,
    stroke: "#C8D8FD",
    strokeWidth: 1
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 134,
    x2: 1030,
    y2: 134,
    stroke: "#86909C",
    strokeWidth: 1,
    strokeDasharray: "5 4"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 302,
    x2: 1030,
    y2: 302,
    stroke: "#F28602",
    strokeWidth: 1.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 316,
    y1: 92,
    x2: 316,
    y2: 525,
    stroke: "#DD1818",
    strokeWidth: 1,
    strokeDasharray: "4 4"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 816,
    y1: 92,
    x2: 816,
    y2: 525,
    stroke: "#39B719",
    strokeWidth: 1,
    strokeDasharray: "4 4"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 316,
    y: 82,
    fontSize: 12,
    fontWeight: 600,
    fill: "#DD1818",
    textAnchor: "middle"
  }, "Desliga de imediatamente abaixo do LTI")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 816,
    y: 82,
    fontSize: 12,
    fontWeight: 600,
    fill: "#206014",
    textAnchor: "middle"
  }, "Volta a ventilar ao atingir hist. Inferior")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 30,
    y: 126,
    fontSize: 12,
    fontWeight: 600,
    fill: "#86909C"
  }, "Temperatura ambiente")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M190,246 L253,263 L316,302 L379,319 L442,302 L526,268 L610,235 L677,212 L757,179 L816,162 L904,138 L1030,128",
    fill: "none",
    stroke: "#F93A3A",
    strokeWidth: 2.5,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 316,
    cy: 302,
    r: 4.5,
    fill: "#DD1818"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 816,
    cy: 162,
    r: 4.5,
    fill: "#39B719"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 1000,
    y1: 162,
    x2: 1000,
    y2: 302,
    stroke: "#86909C",
    strokeWidth: 1
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 994,
    y1: 162,
    x2: 1006,
    y2: 162,
    stroke: "#86909C",
    strokeWidth: 1
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 994,
    y1: 302,
    x2: 1006,
    y2: 302,
    stroke: "#86909C",
    strokeWidth: 1
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 30,
    y: 402,
    fontSize: 12,
    fontWeight: 600,
    fill: "#86909C"
  }, "Capacidade da m\xE1quina")), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M190,490 H316 V525 H816 V490 H1030",
    fill: "none",
    stroke: "#363BC4",
    strokeWidth: 2.5,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 545,
    x2: 1030,
    y2: 545,
    stroke: "#E2E4E9",
    strokeWidth: 1
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    x: 182,
    y: 110,
    fontSize: 12,
    fill: "#86909C",
    textAnchor: "end"
  }, "25 \xB0C"), /*#__PURE__*/React.createElement("text", {
    x: 182,
    y: 138,
    fontSize: 12,
    fill: "#86909C",
    textAnchor: "end"
  }, "24 \xB0C"), /*#__PURE__*/React.createElement("text", {
    x: 182,
    y: 166,
    fontSize: 12,
    fill: "#86909C",
    textAnchor: "end"
  }, "23 \xB0C"), /*#__PURE__*/React.createElement("text", {
    x: 182,
    y: 194,
    fontSize: 12,
    fill: "#86909C",
    textAnchor: "end"
  }, "22 \xB0C"), /*#__PURE__*/React.createElement("text", {
    x: 182,
    y: 250,
    fontSize: 12,
    fill: "#86909C",
    textAnchor: "end"
  }, "20 \xB0C"), /*#__PURE__*/React.createElement("text", {
    x: 182,
    y: 306,
    fontSize: 12,
    fill: "#86909C",
    textAnchor: "end"
  }, "18 \xB0C"), /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 545,
    x2: 190,
    y2: 551,
    stroke: "#86909C"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 316,
    y1: 545,
    x2: 316,
    y2: 551,
    stroke: "#86909C"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 442,
    y1: 545,
    x2: 442,
    y2: 551,
    stroke: "#86909C"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 568,
    y1: 545,
    x2: 568,
    y2: 551,
    stroke: "#86909C"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 694,
    y1: 545,
    x2: 694,
    y2: 551,
    stroke: "#86909C"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 545,
    x2: 820,
    y2: 551,
    stroke: "#86909C"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 946,
    y1: 545,
    x2: 946,
    y2: 551,
    stroke: "#86909C"
  }), /*#__PURE__*/React.createElement("text", {
    x: 190,
    y: 565,
    fontSize: 12,
    fill: "#86909C",
    textAnchor: "middle"
  }, "13:30"), /*#__PURE__*/React.createElement("text", {
    x: 316,
    y: 565,
    fontSize: 12,
    fill: "#86909C",
    textAnchor: "middle"
  }, "14:00"), /*#__PURE__*/React.createElement("text", {
    x: 442,
    y: 565,
    fontSize: 12,
    fill: "#86909C",
    textAnchor: "middle"
  }, "14:30"), /*#__PURE__*/React.createElement("text", {
    x: 568,
    y: 565,
    fontSize: 12,
    fill: "#86909C",
    textAnchor: "middle"
  }, "15:00"), /*#__PURE__*/React.createElement("text", {
    x: 694,
    y: 565,
    fontSize: 12,
    fill: "#86909C",
    textAnchor: "middle"
  }, "15:30"), /*#__PURE__*/React.createElement("text", {
    x: 820,
    y: 565,
    fontSize: 12,
    fill: "#86909C",
    textAnchor: "middle"
  }, "16:00"), /*#__PURE__*/React.createElement("text", {
    x: 946,
    y: 565,
    fontSize: 12,
    fill: "#86909C",
    textAnchor: "middle"
  }, "16:30"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 1042,
    y: 110,
    fontSize: 12,
    fill: "#363BC4"
  }, "Setpoint + histerese superior")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 1042,
    y: 138,
    fontSize: 12,
    fill: "#525866"
  }, "Setpoint")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 1042,
    y: 166,
    fontSize: 12,
    fill: "#363BC4"
  }, "Setpoint \u2212 histerese inferior")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 1042,
    y: 306,
    fontSize: 12,
    fill: "#CA6704"
  }, "LTI")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 1042,
    y: 424,
    fontSize: 12,
    fill: "#86909C"
  }, "Capacidade total")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 1042,
    y: 459,
    fontSize: 12,
    fill: "#86909C"
  }, "Uma condensadora")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 1042,
    y: 494,
    fontSize: 12,
    fill: "#525866"
  }, "Ventila\xE7\xE3o")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 1042,
    y: 529,
    fontSize: 12,
    fill: "#525866"
  }, "Desligado")), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 600,
    x2: 214,
    y2: 600,
    stroke: "#F93A3A",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 222,
    y: 604,
    fontSize: 12,
    fill: "#525866"
  }, "Temperatura ambiente"), /*#__PURE__*/React.createElement("path", {
    d: "M400,605 H406 V600 H412 V595 H418",
    fill: "none",
    stroke: "#363BC4",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 428,
    y: 604,
    fontSize: 12,
    fill: "#525866"
  }, "Capacidade da m\xE1quina"), /*#__PURE__*/React.createElement("line", {
    x1: 620,
    y1: 600,
    x2: 644,
    y2: 600,
    stroke: "#F28602",
    strokeWidth: 2,
    strokeDasharray: "4 3"
  }), /*#__PURE__*/React.createElement("text", {
    x: 652,
    y: 604,
    fontSize: 12,
    fill: "#525866"
  }, "Limite de temperatura inferior (LTI)"))), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 190,
    y: 638,
    fontSize: 12,
    fill: "#86909C"
  }, "Setpoint 24 \xB0C \xB7 histerese inferior 1 \xB0C \xB7 limite de temperatura baixa 18 \xB0C \xB7 retorno \xE0 ventila\xE7\xE3o em 23 \xB0C, sem espera")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtecaoTemperaturaBaixa);
export default __webpack_public_path__ + "static/media/protecao-temperatura-baixa.279ffbce7432232d7ab14219d53aca7a.svg";
export { ForwardRef as ReactComponent };